import React from 'react';
import styles from '@/assets/css/app.less';

const Nav = ({ title, onBack, rightNavConfig = [], withBorder = true }) => {
  const onBackClick = e => {
    e.preventDefault();
    console.log('点击导航栏返回键');
    onBack();
  };
  const onNavClick = (e, onNav) => {
    e.preventDefault();
    onNav();
  };

  return (
    <header className={`${styles['hd']} ${withBorder ? styles['with-border'] : ''}`}>
      <h1>{title}</h1>
      <a href="/#" className={styles['back']} onClick={e => onBackClick(e)}>
        <i className={`${styles['afont']} ${styles['icon-prev']}`}></i>
      </a>
      {!!rightNavConfig.length && (
        <div className={styles['hd-right']}>
          {rightNavConfig.map((item, index) =>
            React.isValidElement(item) ? (
              <div key={index} className={styles['component-wrapper']}>
                {item}
              </div>
            ) : (
              <a href="#/" key={index} onClick={e => onNavClick(e, item.onNavClick)}>
                {item.name}
              </a>
            )
          )}
        </div>
      )}
    </header>
  );
};

export default Nav;
